import {Component, Input} from '@angular/core';
import {FormGroup} from "@angular/forms";
import {
  FieldSelectedConfiguration
} from "../../models/field-configuration-selected-field/field-configuration-selected-field.model";

@Component({
  selector: 'app-form-switch',
  templateUrl: './form-switch.component.html',
  styleUrls: ['./form-switch.component.sass']
})
export class FormSwitchComponent {
  @Input() formGroup: FormGroup = new FormGroup({});
  @Input() inputSetting!: FieldSelectedConfiguration;

  get isRequired(): boolean {
    return this.inputSetting?.required ?? false;
  }
}
